import React, {
  useEffect,
  useMemo,
  useReducer,
  useState,
} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { resetPassword as resetPasswordAction } from "../../../actions/auth.action.entry";
import * as Yup from "yup";
import SimpleReactValidator from "simple-react-validator";
import { reactValidatorOptions } from "../../../helpers/simpleReactValidator";
import PageBackground from "../../../components/pageBackground.component";
import CardBody from "../../../components/CardBody/cardBody.component";
import InputForm from "../../../components/InputForm/inputForm.component";
import PrimaryButton from "../../../components/primaryButton.component";
import ErrorBox from "../../../components/errorBox.component";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getParmeterConfigAction } from "../../../actions/applications.action";

/**
 * Reset Password Component (sends an e-mail form and makes a post
 * request for user verification).
 *
 * @export Function Component
 * @returns Redux connect
 */
export const ResetPassword = ({
  appName,
  tenant,
  history,
  loadingReducer,
  resetPassword,
  parameterConfig,
}) => {
  /**
   * Set validation email schema with parameter config from database
   */
  const validationSchema = useMemo(() => {
    let regex = new RegExp(
      "(?!.*?\\.\\.)([A-Za-z0-9_\\-.+]{3,})+@([A-Za-z0-9_\\-.]{3,})+\\.([A-Za-z]{2,})",
    );
    if (parameterConfig?.regexPatternFormEmails) {
      regex = new RegExp(parameterConfig.regexPatternFormEmails);
    }
    return Yup.object().shape({
      email: Yup.string()
        .max(100)
        .required("Ingresa un email valido")
        //.email('El formato de email ingresado no es válido. Inténtalo de nuevo.')
        .matches(
          regex,
          "El formato de email ingresado no es válido. Inténtalo de nuevo.",
        ),
    });
  }, [parameterConfig]);

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },

    resolver: yupResolver(validationSchema),
  });

  const email = watch("email");
  const errorMessage = email ? Object.values(errors)[0]?.message ?? "" : "";
  const [, forceUpdate] = useReducer((n) => n + 1, 0);

  // Lazy initial state: the validator is created only once
  const [validator] = useState(
    () => new SimpleReactValidator(reactValidatorOptions),
  );

  // Derived directly from props, no need to copy it into local state
  const loading = loadingReducer.loading;

  const setResetPassword = () => {
    //e.preventDefault();
    const userData = {
      user: email,
      appname: appName,
    };
    resetPassword(userData, history, "", tenant);
    forceUpdate();
  };

  useEffect(() => {
    getParmeterConfigAction(appName, 'ParameterApps');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const returnToLogin = (e) => {
    e.preventDefault();
    history.push({ pathname: "/Login" });
  };

  return (
    <div className="login">
      <PageBackground></PageBackground>
      <CardBody title="Recordar Contraseña">
        <hr></hr>
        <Typography style={{ textAlign: "center", color: "#706F6F" }}>
          Ingrese su email y recibirá un correo con las instrucciones para
          restablecer su contraseña
          <br />
          <br />
        </Typography>
        <Controller
          control={control}
          name={"email"}
          render={({ value, onChange }) => (
            <InputForm
              placeholder={" E-mail"}
              icon={"Email"}
              id="email"
              onChange={onChange}
              value={value}
              validator={validator}
              validateOptions={"required|email"}
            />
          )}
        />
        {errorMessage && (
          <>
            <br />
            <ErrorBox value={errorMessage} appName={appName}></ErrorBox>
          </>
        )}
        <br />
        <Grid container spacing={2} justifyContent="center">
          <Grid item lg={4}>
            <PrimaryButton
              name={"cancelar"}
              txtBtn={"Cancelar"}
              onClick={returnToLogin}
            ></PrimaryButton>
          </Grid>
          <Grid item lg={4}>
            <PrimaryButton
              name={"enviar"}
              txtBtn={"Enviar"}
              loading={loading}
              onClick={handleSubmit(setResetPassword)}
            ></PrimaryButton>
          </Grid>
        </Grid>
      </CardBody>
    </div>
  );
};

ResetPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  authReducer: PropTypes.object.isRequired,
  loadingReducer: PropTypes.object.isRequired,
  tenant: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  loadingReducer: state.loadingReducer,
  parameterConfig: state.applicationsReducer.parameterConfig,
});

const mapDispatchToProps = {
  resetPassword: resetPasswordAction,
  getParmeterConfigAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword,);
